module.exports = __webpack_public_path__ + "img/bar.adbcb10.svg";